import React from 'react'
import { IUserDetails } from '../../../interfaces/user.interface'
import { ICourse, ICourseLessonContent } from '../../../interfaces/ICourse'
import { IPaymentsPlan } from '../../../interfaces/IPaymentsPlan'
import { ISchool } from '../../../interfaces/school.interface'
import PageDescriptionComponent from '../../HelpfulGuides/PageDescriptionComponent'
import BaseBreadcrumbComponent from '../../Breadcrumbs/BaseBreadcrumpComponent'
import { Card, CardContent, Paper, Typography, useTheme } from '@mui/material'
import CurrencyCodeComponent from '../../CurrencyComponents/CurrencyCodeComponent'
import LessonExpansionComponent from '../../Classroom/ClassroomLearnersComponents/SchoolCourseDetails/LessonExpansionComponent'
import CourseDetailsActionComponent from './CourseDetailsActionComponent'
import MyViewEditorHtml from '../../MyEditor/MyViewEditorHtml'
import CourseDetailsActionComponentMedia from './CourseDetailsActionComponentMedia'
import { formatAmount } from '../../../services/utils'
import CourseDetailsOtherCoursesComponent from './CourseDetailsOtherCoursesComponent'

interface ICourseInfo {
  schoolDetailsFromCourse: ISchool
  courseDetails: ICourse
  courseLessonContent: Array<ICourseLessonContent>
  paymentPlans: IPaymentsPlan[]
  userDetails: IUserDetails | undefined
}

const CourseDetailsComponentLarge = (props: ICourseInfo) => {
  const theme = useTheme()
  return (
    <div
      style={{
        // backgroundColor: '#1a1c1e',
        backgroundColor: '#fafafa',
        minHeight: '100vh',
        paddingBottom: '100px',
      }}
    >
      <div
        style={{
          padding: '30px 10px',
        }}
      >
        <div style={{ maxWidth: '1100px', margin: 'auto' }}>
          <PageDescriptionComponent
            padding={'0px 0px'}
            backgroundColor={'inherit'}
            textContent={
              <BaseBreadcrumbComponent
                items={[
                  { path: '/', title: 'Home', style: { color: 'grey' } },
                  {
                    path: `/course-details/${
                      props.courseDetails.slug || props.courseDetails._id
                    }`,
                    title: props.courseDetails.name,
                    isActive: true,
                    style: { color: theme.palette.primary.main },
                  },
                ]}
              />
            }
          />
          <div
            style={{
              maxWidth: 'calc(100% - 450px)',
              paddingLeft: '20px',
            }}
          >
            <Typography
              gutterBottom={true}
              variant="h4"
              style={{
                wordBreak: 'break-word',
              }}
            >
              <b> {props.courseDetails.name} </b>
            </Typography>
            <Typography variant={'body2'}>
              course code: {props.courseDetails.course_code}
            </Typography>
            <Typography>{props.courseDetails.short_description}</Typography>

            {props.courseDetails && Boolean(props.courseDetails.price) && (
              <div style={{ padding: '0px' }}>
                <Typography
                  variant={'h5'}
                  style={{
                    color: theme.palette.primary.light,
                  }}
                >
                  <CurrencyCodeComponent
                    school={props.schoolDetailsFromCourse}
                  />
                  <b>{' ' + formatAmount(props.courseDetails.price)}</b>
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          minHeight: '200px',
          alignItems: 'flex-start',
          maxWidth: '1100px',
          margin: 'auto',
          backgroundColor: 'inherit',
        }}
      >
        <div
          style={{
            maxWidth: 'calc(100% - 450px)',
            width: '100%',
            padding: '0px 20px',
          }}
        >
          {/*<div>*/}
          {/*  <CourseDetailsClusterList*/}
          {/*    school={props.schoolDetails}*/}
          {/*    paymentPlans={props.paymentPlans}*/}
          {/*  />*/}
          {/*</div>*/}
          <div>
            <Typography variant={'h6'}>
              <b>Course details</b>
            </Typography>
            <MyViewEditorHtml notes={props.courseDetails.description} />
          </div>

          <div>
            <div>
              <Typography
                style={{
                  paddingTop: '20px',
                }}
                gutterBottom={true}
                variant={'h6'}
              >
                <b>Course outline</b>
              </Typography>
              <Paper
                variant={'outlined'}
                style={{
                  border: 'none',
                  backgroundColor: 'inherit',
                }}
              >
                <LessonExpansionComponent
                  courseDetails={props.courseDetails}
                  courseLessonContents={props.courseLessonContent}
                />
              </Paper>
            </div>
          </div>
          {Boolean(props.courseDetails.requirements) && (
            <Paper
              style={{
                padding: '5px',
                width: '100%',
                border: 'none',
                maxWidth: '700px',
                backgroundColor: 'initial',
              }}
              variant={'outlined'}
            >
              <Typography gutterBottom={true} variant={'h6'}>
                Course requirements
              </Typography>
              <Typography>
                {props.courseDetails.requirements ||
                  'There are no requirements for you to take this course'}
              </Typography>
            </Paper>
          )}
          {Boolean(props.courseDetails.tutorDescription) && (
            <div
              style={{
                padding: '5px',
                width: '100%',
                maxWidth: '700px',
                border: 'none',
                backgroundColor: 'initial',
              }}
            >
              <Typography gutterBottom={true} variant={'h6'}>
                <b>About the tutor</b>
              </Typography>
              <Typography>{props.courseDetails.tutorDescription}</Typography>
            </div>
          )}
        </div>
        <Card
          style={{
            width: '350px',
            minHeight: '300px',
            marginTop: '-300px',
            position: 'sticky',
            top: '85px',
            // backgroundColor: "#212330",
            // backgroundColor: '#25282b',
            // color: '#fafafa',
            borderBottom: `${theme.palette.primary.light} 2px solid`,
          }}
        >
          <CourseDetailsActionComponentMedia
            courseDetails={props.courseDetails}
          />

          <CardContent>
            <div style={{ padding: '5px' }}>
              <CourseDetailsActionComponent
                courseDetails={props.courseDetails}
                schoolDetailsFromCourse={props.schoolDetailsFromCourse}
                userDetails={props.userDetails}
                paymentPlans={props.paymentPlans}
                courseLessonContent={props.courseLessonContent}
              />
            </div>
          </CardContent>
        </Card>
      </div>
      <div style={{ height: '100px' }} />
      {!props.courseDetails?.hide_related_courses &&
        !props.schoolDetailsFromCourse?.limit_discovery_to_faculties && (
          <>
            <CourseDetailsOtherCoursesComponent
              schoolDetailsFromCourse={props.schoolDetailsFromCourse}
              currentCourseId={props.courseDetails?._id}
            />
            <div style={{ height: '10px' }} />
          </>
        )}
    </div>
  )
}

export default CourseDetailsComponentLarge
